// OOXML namespace prefixes vary across documents, so these helpers try
// multiple resolution strategies rather than relying on a single prefix.

export function getChildren(el: Element, localName: string): Element[] {
    const result: Element[] = [];
    for (let i = 0; i < el.childNodes.length; i++) {
        const node = el.childNodes[i];
        if (node instanceof Element && node.localName === localName) {
            result.push(node);
        }
    }
    return result;
}

export function getChild(
    el: Element,
    localName: string
): Element | null {
    return getChildren(el, localName)[0] ?? null;
}

export function getAttr(el: Element, localName: string): string {
    for (const prefix of ['w:', 'r:', '']) {
        const val = el.getAttribute(`${prefix}${localName}`);
        if (val) return val;
    }
    for (const ns of [
        'http://schemas.openxmlformats.org/wordprocessingml/2006/main',
        'http://schemas.openxmlformats.org/officeDocument/2006/relationships',
    ]) {
        const val = el.getAttributeNS(ns, localName);
        if (val) return val;
    }
    return '';
}

export function findAll(el: Element, localName: string): Element[] {
    return Array.from(el.getElementsByTagName('*')).filter(
        (e) => e.localName === localName
    );
}

export function parseXml(xml: string, label: string): Document {
    const doc = new DOMParser().parseFromString(xml, 'application/xml');
    const err = doc.querySelector('parsererror');
    if (err)
        throw new Error(
            `Malformed ${label}: ${err.textContent?.slice(0, 100)}`
        );
    return doc;
}

const WRAPPER_ELEMENTS = new Set([
    'ins',
    'del',
    'moveTo',
    'moveFrom',
    'sdt',
    'sdtContent',
    'smartTag',
    'customXml',
]);

export function flattenChildren(el: Element): Element[] {
    const result: Element[] = [];
    for (let i = 0; i < el.childNodes.length; i++) {
        const node = el.childNodes[i];
        if (!(node instanceof Element)) continue;
        if (WRAPPER_ELEMENTS.has(node.localName)) {
            result.push(...flattenChildren(node));
        } else {
            result.push(node);
        }
    }
    return result;
}
